import { Component, OnDestroy } from '@angular/core';
import { NbThemeService } from '@nebular/theme';
import { takeWhile } from 'rxjs/operators';

@Component({
  selector: 'ngx-blank-layout',
  styleUrls: ['./blank.layout.scss'],
  template: `
    <nb-layout>
      <nb-layout-column class="content">
        <ng-content></ng-content>
      </nb-layout-column>
    </nb-layout>
  `,
})
export class BlankLayoutComponent implements OnDestroy {

  private alive = true;

  currentTheme: string;

  constructor(protected themeService: NbThemeService) {
    this.themeService.getJsTheme()
      .pipe(takeWhile(() => this.alive))
      .subscribe(theme => {
        this.currentTheme = theme.name;
    });
  }

  ngOnDestroy() {
    this.alive = false;
  }
}
